import { useCallback, useRef, useEffect } from "react";
const USD_Intl_Format = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});
const formatCurrencyNumber = (num) => {
  return `${num}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
const formatIntlUSD = (value, removeTrailingZeroes = true) => {
  let numberValue = Number(value);
  if (Number.isNaN(numberValue)) numberValue = 0;
  return removeTrailingZeroes ? USD_Intl_Format.format(numberValue).replace(".00", "") : USD_Intl_Format.format(numberValue);
};
const addZeroes = (num) => {
  const value = Number(num);
  const res = String(num).split(".");
  if (res.length === 1 || res[1].length <= 3)
    return Number(value.toFixed(2).replace(/\.00$/, ""));
  return value;
};
const truncateString = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
};
const toMs = (seconds) => {
  return seconds * 1e3;
};
const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const tick = () => {
      if (savedCallback.current) savedCallback.current();
    };
    {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
function propUpdated(props, oldProps, keys) {
  return keys.reduce((a, b) => {
    if (a) {
      return a;
    }
    return props[b] !== oldProps[b];
  }, false);
}
function getDonorLevel(amount) {
  const donorAmount = Math.trunc(Number.parseFloat(amount));
  if (donorAmount >= 100) return "platinum";
  if (donorAmount >= 75) return "gold";
  if (donorAmount >= 50) return "silver";
  if (donorAmount >= 25) return "bronze";
  return "grey";
}
function getGTGLevel(amount) {
  const donorAmount = Math.trunc(Number.parseFloat(amount));
  if (donorAmount === 5)
    return {
      description: "a No More Chemo Party",
      iconName: "nochemo",
      size: "small"
    };
  if (donorAmount === 10)
    return {
      description: "a new toy for St. Jude",
      iconName: "toys",
      size: "small"
    };
  if (donorAmount === 25)
    return {
      description: "one day of meals for a patient",
      iconName: "food",
      size: "big"
    };
  if (donorAmount === 50)
    return {
      description: "art supplies for St. Jude",
      iconName: "art",
      size: "small"
    };
  if (donorAmount === 100)
    return {
      description: "a red wagon for St. Jude",
      iconName: "wagon",
      size: "small"
    };
  if (donorAmount === 300)
    return {
      description: "groceries for a family for two weeks",
      iconName: "food",
      size: "big"
    };
  if (donorAmount === 500)
    return {
      description: "two days of oxygen for a patient",
      iconName: "doctor",
      size: "big"
    };
  if (donorAmount === 1e3)
    return {
      description: "airfare for patients and families",
      iconName: "travel",
      size: "big"
    };
  if (donorAmount === 1500)
    return {
      description: "one day of chemotherapy for a patient",
      iconName: "chemo",
      size: "big"
    };
  return { description: "", iconName: "", size: "" };
}
const useFormatDonorAmount = () => {
  return useCallback((amount) => {
    if (typeof amount === "number") {
      return formatIntlUSD(amount);
    }
    return formatIntlUSD(amount.value);
  }, []);
};
export {
  addZeroes,
  formatCurrencyNumber,
  formatIntlUSD,
  getDonorLevel,
  getGTGLevel,
  propUpdated,
  toMs,
  truncateString,
  useFormatDonorAmount,
  useInterval
};
//# sourceMappingURL=utils.js.map
